import { io } from "socket.io-client";

const isLocalNetwork =
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1";

const backendDomain =
  process.env.NODE_ENV === "development"
    ? isLocalNetwork
      ? `http://${window.location.hostname}:5000`
      : "http://localhost:5000"
    : process.env.NODE_ENV === "production"
      ? "https://apd-group-biz.onrender.com"
      : "http://192.168.0.15:5000";

const socket = io(
  backendDomain,

  {
    transports: ["websocket"],
  },
);

export default socket;
